import { render } from "./CereriConcediu.vue?vue&type=template&id=dc915784&scoped=true&ts=true"
import script from "./CereriConcediu.vue?vue&type=script&lang=ts"
export * from "./CereriConcediu.vue?vue&type=script&lang=ts"

import "./CereriConcediu.vue?vue&type=style&index=0&id=dc915784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc915784"]])

export default __exports__